import { getAuthWithAppName } from "../../auth/index";
import { patchRestCall, deleteRestCall } from "../../../services/rest-api-call";
import { getNcsNotifications } from "../../../services/state-utils/get-ncs-notifications";
import { getUserProfile } from "../../../services/state-utils/get-user-profile";

import { API_PDC_URL_V1 } from "../../../../config";

export const writeConstants = {
  UPDATE_NCS_SINGLE_NOTIFICATION_START: "UPDATE_NCS_SINGLE_NOTIFICATION_START",
  UPDATE_NCS_SINGLE_NOTIFICATION_ERROR: "UPDATE_NCS_SINGLE_NOTIFICATION_ERROR",
  UPDATE_NCS_SINGLE_NOTIFICATION_SUCCESS: "UPDATE_NCS_SINGLE_NOTIFICATION_SUCCESS",

  UPDATE_NCS_NOTIFICATIONS_LIST_START: "UPDATE_NCS_NOTIFICATIONS_LIST_START",
  UPDATE_NCS_NOTIFICATIONS_LIST_ERROR: "UPDATE_NCS_NOTIFICATIONS_LIST_ERROR",
  UPDATE_NCS_NOTIFICATIONS_LIST_SUCCESS: "UPDATE_NCS_NOTIFICATIONS_LIST_SUCCESS",

  DELETE_NOTIFICATIONS_LIST_START: "DELETE_NOTIFICATIONS_LIST_START",
  DELETE_NOTIFICATIONS_LIST_ERROR: "DELETE_NOTIFICATIONS_LIST_ERROR",
  DELETE_NOTIFICATIONS_LIST_SUCCESS: "DELETE_NOTIFICATIONS_LIST_SUCCESS",

  DELETE_SINGLE_NOTIFICATION_START: "DELETE_SINGLE_NOTIFICATION_START",
  DELETE_SINGLE_NOTIFICATION_ERROR: "DELETE_SINGLE_NOTIFICATION_ERROR",
  DELETE_SINGLE_NOTIFICATION_SUCCESS: "DELETE_SINGLE_NOTIFICATION_SUCCESS"
};

export function updateSingleNotification(
  auth, ncsId, notificationId, request
) {
  return async(dispatch, getState) => {
    const prevNotifications = getNcsNotifications(getState());

    dispatch({
      type: writeConstants.UPDATE_NCS_SINGLE_NOTIFICATION_START,
      payload: { ncsId, notificationId, request }
    });

    const requestUrl = `${API_PDC_URL_V1}/notifications/${ncsId}/web/${notificationId}`;
    const authObj = getAuthWithAppName(auth);

    try {
      const response = await patchRestCall(
        requestUrl, authObj, null, request, dispatch, authObj.refreshToken, getUserProfile(getState()), undefined, false
      );

      dispatch({
        type: writeConstants.UPDATE_NCS_SINGLE_NOTIFICATION_SUCCESS,
        payload: {
          ...response
        }
      });
    } catch (e) {
      dispatch({
        type: writeConstants.UPDATE_NCS_SINGLE_NOTIFICATION_ERROR,
        error: e,
        payload: { ncsId, prevNotifications }
      });
    }
  };
}

export function updateNotificationsList(
  auth, ncsId, request
) {
  return async(dispatch, getState) => {
    const prevNotifications = getNcsNotifications(getState());

    dispatch({
      type: writeConstants.UPDATE_NCS_NOTIFICATIONS_LIST_START,
      payload: { ncsId, request }
    });

    const requestUrl = `${API_PDC_URL_V1}/notifications/${ncsId}/web`;
    const authObj = getAuthWithAppName(auth);

    try {
      const response = await patchRestCall(
        requestUrl, authObj, null, request, dispatch, authObj.refreshToken, getUserProfile(getState()), undefined, false
      );

      dispatch({
        type: writeConstants.UPDATE_NCS_NOTIFICATIONS_LIST_SUCCESS,
        payload: {
          ...response
        }
      });
    } catch (e) {
      dispatch({
        type: writeConstants.UPDATE_NCS_NOTIFICATIONS_LIST_ERROR,
        error: e,
        payload: { ncsId, prevNotifications }
      });
    }
  };
}

export function deleteNotificationsList(auth, ncsId) {
  return async(dispatch, getState) => {
    const prevNotifications = getNcsNotifications(getState());

    dispatch({
      type: writeConstants.DELETE_NOTIFICATIONS_LIST_START,
      payload: { ncsId }
    });

    const requestUrl = `${API_PDC_URL_V1}/notifications/${ncsId}/web`;
    const authObj = getAuthWithAppName(auth);

    try {
      const response = await deleteRestCall(
        requestUrl, authObj, null, null, dispatch, authObj.refreshToken, getUserProfile(getState()), undefined, false
      );

      dispatch({
        type: writeConstants.DELETE_NOTIFICATIONS_LIST_SUCCESS,
        payload: {
          ...response
        }
      });
    } catch (e) {
      dispatch({
        type: writeConstants.DELETE_NOTIFICATIONS_LIST_ERROR,
        error: e,
        payload: { ncsId, prevNotifications }
      });
    }
  };
}

export function deleteSingleNotification(
  auth, ncsId, notificationId
) {
  return async(dispatch, getState) => {
    const prevNotifications = getNcsNotifications(getState());

    dispatch({
      type: writeConstants.DELETE_SINGLE_NOTIFICATION_START,
      payload: { ncsId, notificationId }
    });

    const requestUrl = `${API_PDC_URL_V1}/notifications/${ncsId}/web/${notificationId}`;
    const authObj = getAuthWithAppName(auth);

    try {
      await deleteRestCall(
        requestUrl, authObj, null, null, dispatch, authObj.refreshToken, getUserProfile(getState()), undefined, false
      );

      dispatch({
        type: writeConstants.DELETE_SINGLE_NOTIFICATION_SUCCESS,
        payload: {
          notificationId
        }
      });
    } catch (e) {
      dispatch({
        type: writeConstants.DELETE_SINGLE_NOTIFICATION_ERROR,
        error: e,
        payload: { ncsId, prevNotifications }
      });
    }
  };
}
